module.exports = __webpack_public_path__ + "static/media/9.d8c0f524.svg";